export default {
  ACTIVE: "active",
  ONCE: "once",
  INACTIVE: "inactive",
};
